import axios from 'axios';

const state= {
    Items:{
        data:[],
        total:0
    }
};

const getters = {
    Items : (state) => state.Items,
};

const actions = {
    getItems({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/order-approval-log`,{
                params: params
            })
                .then(response => {
                    commit( 'setItems', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    createItem({commit},param){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/order-approval-log`,param)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    async getNextApprover({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/approval/next-approver`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items.data = data.items;
        state.Items.total = data.total;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}